import { Outlet } from 'react-router-dom';
import { TopBar } from 'client/views/navigation/top-bar/top-bar';
import { ProjectSideBar } from 'client/views/navigation/project-side-bar/project-side-bar';
import { useCompanyContext } from 'client/hooks/use-company-context';
import 'client/views/request-interceptor';
import { Flex, Spinner } from '@oliasoft-open-source/react-ui-library';

export const MainContainer = () => {
  const { isReady } = useCompanyContext();

  if (!isReady) {
    return <Flex justifyContent="center"><Spinner dark tiny /></Flex>;
  }

  return (
    <>
      <TopBar />
      <ProjectSideBar />
      <Outlet />
    </>
  );
};
